import React, { useState, useEffect } from 'react';
import { Loader2, X } from 'lucide-react';

const ScanStatus = () => {
  if (true) return null;

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between px-4 py-3 bg-cyan-400/5 border border-cyan-400/20 rounded-xl">
        <div className="flex items-center gap-3">
          <Loader2 className="w-4 h-4 text-cyan-400 animate-spin flex-shrink-0" />
          <div>
            <p className="text-sm font-medium text-gray-200">Scan status not available</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScanStatus;
